module.exports = __webpack_public_path__ + "img/TradingView-img1.f6cb1cad.png";